import { createGlobalStyle } from 'styled-components';

const DASHED_BORDER = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23467FCFFF' stroke-width='2' stroke-dasharray='5 10 ' stroke-dashoffset='5' stroke-linecap='round'/%3e%3c/svg%3e")`;

/**
 * AMI's react-dropzone-uploader rules, moved out of custom.css for DropzonePlaceholder. Selectors, values,
 * !important flags and source order are ported 1:1 rather than mapped to tokens, so the Document Upload
 * preview looks exactly as before. custom.css's two .profile-doc-upload blocks are merged into their effective
 * values (the later padding: 0 !important overrode padding-bottom: 60px). Mount once (library/GlobalStyles.js):
 * every mounted copy injects the rules again.
 */
export const DropzonePlaceholderGlobalStyle = createGlobalStyle({
    '.dzu-dropzone': {
        border: '1px solid #d7dee8 !important',
        borderRadius: '2px',
        overflow: 'hidden',
    },
    '.profile-doc-upload': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '0 !important',
    },
    ".profile-doc-upload input[type='file']": {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: '0',
        cursor: 'pointer',
    },
    '.profile-doc-upload lable i': {
        fontSize: '55px',
        color: '#467fcf',
        marginBottom: '20px',
    },
    '.profile-doc-upload lable h4': {
        color: '#06172a',
        fontSize: '17px',
        fontWeight: '700',
        marginBottom: '10px',
    },
    '.profile-doc-upload lable h4 span': {
        color: '#467fcf',
    },
    '.profile-doc-upload lable p': {
        color: '#484644',
        fontSize: '15px',
        margin: '0',
    },
    '.profile-doc-upload lable': {
        backgroundImage: DASHED_BORDER,
        borderRadius: '8px',
        display: 'block',
        padding: '51px 20px',
        textAlign: 'center',
        width: '100%',
        height: '100%',
    },
    '.profile-doc-upload .dzu-dropzone lable': {
        backgroundImage: 'none',
    },
    '.profile-doc-upload .dzu-dropzone': {
        border: 'transparent !important',
        backgroundImage: DASHED_BORDER,
    },
});
